import React, { useState } from 'react';
import './Menu.css';

import { Heading, MenuItem } from '../../../components';
import { menu } from '../../../constants';



const MenuSection = () => {

  // State to track the active (selected) category
  const [activeCategory, setActiveCategory] = useState(Object.keys(menu)[0]);

  // Format category keys for display
  const formatCategoryName = (key) => {
    return key
      .replace(/([A-Z])/g, ' $1') // Add space before capital letters
      .replace(/^./, str => str.toUpperCase()); // Capitalize first letter
  };

  return (
    <section className="menu">

      {/* Section Heading */}
      <Heading title={'Our menu'} />

      <div className="content">

        {/* Menu Category Tabs */}
        <div className="tab-buttons">
          {Object.keys(menu).map(categoryKey => (
            <button
              key={categoryKey}
              type="button"
              className={`button ${activeCategory === categoryKey ? 'active' : ''}`}
              onClick={() => setActiveCategory(categoryKey)} // Update active category on click
            >
              {formatCategoryName(categoryKey)}
            </button>
          ))}
        </div>

        {/* Menu Items by Category */}
        <div className="box-container">
          {Object.entries(menu).map(([categoryKey, items]) => (
            <div
              key={categoryKey}
              className={`menu-gallery ${activeCategory === categoryKey ? 'active' : ''}`}
              id={categoryKey}
            >
              {/* Render each Menu Item */}
              {items.map(item => (
                <MenuItem key={`${categoryKey}-${item.id}`} item={item} />
              ))}
            </div>
          ))}
        </div>

      </div>

    </section>
  );
};

export default MenuSection;